import { useCallback } from 'react';

import { usePromotePageState } from 'src/app/pages/promote/pageContext';
import { usePaymentTokenFunctions, usePrePaymentChecks, useValidate } from 'src/app/pages/promote/shared/hooks';
import { isLoading } from 'src/app/shared/utils/async';
import type { PaymentType } from 'src/app/shared/utils/payments';

type Result = ModelHookResult<
	{
		loading: boolean;
	},
	{
		onClick: (paymentType: PaymentType) => Promise<void>;
	}
>;

export function useSavedPaymentMethodButton(): Result {
	const [{ formState }] = usePromotePageState();
	const { beforeToken, withToken } = usePaymentTokenFunctions();
	const validate = useValidate();
	const prePaymentChecks = usePrePaymentChecks();

	const onClick = useCallback(
		async (paymentType: PaymentType) => {
			await beforeToken(paymentType);
			if (!(await validate(paymentType))) return;
			if (!(await prePaymentChecks(paymentType))) return;
			await withToken({ paymentType });
		},
		[beforeToken, validate, prePaymentChecks, withToken],
	);

	return {
		data: {
			loading: isLoading(formState),
		},
		actions: {
			onClick,
		},
	};
}
